import React from 'react'
import trueview from '../assets/images/1-min.png';
import oow from '../assets/images/2-min.png';
import victory from '../assets/images/3-min.png';
import tresdias from '../assets/images/4-min.png';
import paralaps from '../assets/images/6-min.png';
import pressurewashing from '../assets/images/8-min.png';
import sototrim from '../assets/images/7-min.png';
import mittul from '../assets/images/mittul.png';
import yippezy from '../assets/images/yippezy.png';
import housefull from '../assets/images/housefull.png';
import accelence from '../assets/images/accelence.png';
import urbannext from '../assets/images/urbannext.png';
import stories from '../assets/images/stories.png';
import pamco from '../assets/images/pamco.png';
import elite from '../assets/images/elite.png';
import cutabove from '../assets/images/cutabove.png';
import saaksham from '../assets/images/saaksham.png';
import greenly from '../assets/images/greenly.png';
import trumbul from '../assets/images/trumbul.png';
import glasplex from '../assets/images/glasplex.png';
import uttam from '../assets/images/uttam.png';
import genzephyr from '../assets/images/genzephyr.png';
import turnkey from '../assets/images/turnkey.png';
import supplementfarm from '../assets/images/supplementfarm.png';
import soil from '../assets/images/soil.png';
import digi from '../assets/images/digi.png';
import cicl from '../assets/images/cicl.png';
import decrayze from '../assets/images/decrayze.png';
import luxuria from '../assets/images/luxuria.png';
import vavo from '../assets/images/vavo.png';
import travelinfoline from '../assets/images/5-min.png';
import amrit from '../assets/images/amrit.png';
import sweetroars from '../assets/images/sweetroars.png';
import stelliam from '../assets/images/stelliam.png';
import podcrafter from '../assets/images/podcrafter.png';
import marudeva from '../assets/images/marudeva.png';
import fp from '../assets/images/fp.png';
import cf from '../assets/images/cf.png';
import parimisha from '../assets/images/parimisha.png';
import monarch from '../assets/images/monarch.png';
import melavi from '../assets/images/melavi.png';
import logsday from '../assets/images/logsday.png';
import ciclevent from '../assets/images/ciclevent.png';
import arken from '../assets/images/arken.png';
import cheerup from '../assets/images/cheerup.png';
import ora from '../assets/images/ora.png';
import citycool from '../assets/images/citycool.png';
import ultucup from '../assets/images/ultucup.png';
import remodelingusa from '../assets/images/remodelingusa.png';
import goglobe from '../assets/images/goglobe.png';
import '../assets/styles/Project.scss';

export default function WordPressProjects() {
  return (
   <div className="projects-container" id="projects">
        <h1 className='tech-title'>WordPress Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://storiesunwired.com" rel="noreferrer" target="_blank">
                <img src={stories} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://storiesunwired.com" rel="noreferrer" target="_blank">Stories Unwired - Figma to Wordpress</a></h2>
                <p>Stories Unwired – A clean, responsive marketing agency website developed with Figma to WordPress for providing services and growth of businesses.</p>
            </div>
            <div className="project">
                <a href="https://firstpartnerconsulting.com/" rel="noreferrer" target="_blank">
                <img src={fp} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://firstpartnerconsulting.com/" rel="noreferrer" target="_blank">First Partner - Investment and Growth Business</a></h2>
                <p>A stylish modern Figma to WordPress 18-20 pages site with smooth transitions and responsive design.</p>
            </div>
            <div className="project">
                <a href="https://uttamsfurniture.in" rel="noreferrer" target="_blank">
                <img src={uttam} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://uttamsfurniture.in/" rel="noreferrer" target="_blank">Uttam's Furniture - Furniture and Interior Designs</a></h2>
                <p>A stylish modern WordPress website with 8-10 pages, featuring smooth transitions and responsive design.</p>
            </div>
            <div className="project">
                <a href="https://www.cutabove.co.in" rel="noreferrer" target="_blank">
                <img src={cutabove} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://www.cutabove.co.in" rel="noreferrer" target="_blank">Cut Above - Figma to Wix Sudio</a></h2>
                <p>A modern, visually refined Wix website developed from Figma layouts to present high-end kitchen and living solutions effectively.</p>
            </div>
            <div className="project">
                <a href="https://turnkeypropertyinspectors.com" rel="noreferrer" target="_blank">
                <img src={turnkey} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://turnkeypropertyinspectors.com" rel="noreferrer" target="_blank">Turn Key Property Inspectors – Professional Home Inspection Services</a></h2>
                <p>Developed a modern, responsive website for a certified home inspection company, showcasing residential inspection services, service areas, company credentials, and an intuitive user experience for home buyers and property owners.</p>
            </div>
            <div className="project">
                <a href="https://glasplexplasti.wpenginepowered.com" rel="noreferrer" target="_blank">
                <img src={glasplex} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://glasplexplasti.wpenginepowered.com" rel="noreferrer" target="_blank">Glasplex Plastics – Industrial Plastic Sheet Supplier & Custom Fabrication</a></h2>
                <p>Designed and developed a professional business website for an industrial plastic sheet supplier, featuring product categories, custom fabrication solutions, responsive design, and optimized performance.</p>
            </div>
            <div className="project">
                <a href="https://pamco.ca" rel="noreferrer" target="_blank">
                <img src={pamco} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://pamco.ca" rel="noreferrer" target="_blank">Pamco – Sexual & Reproductive Health Products</a></h2>
                <p>Developed a clean, responsive website for a healthcare brand, showcasing sexual and reproductive health products with an accessible, user-friendly design and optimized browsing experience.</p>
            </div>
            <div className="project">
                <a href="https://remodelingusa.wpenginepowered.com" rel="noreferrer" target="_blank">
                <img src={remodelingusa} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://remodelingusa.wpenginepowered.com" rel="noreferrer" target="_blank">Remodeling USA – Home Remodeling & Renovation Services</a></h2>
                <p>Developed a modern, responsive website for a home remodeling company, showcasing renovation services, design expertise, and value-driven home improvement solutions with a seamless and engaging user experience.</p>
            </div>
            <div className="project">
                <a href="https://monarchtexascleaning.com" rel="noreferrer" target="_blank">
                <img src={monarch} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://monarchtexascleaning.com" rel="noreferrer" target="_blank">Monarch Texas Cleaning Services – Residential & Commercial Cleaning</a></h2>
                <p>Developed a clean, responsive website for a professional cleaning company, showcasing residential and commercial cleaning services, service areas, and an easy-to-navigate user experience for customers seeking reliable cleaning solutions.</p>
            </div>
                    <div className="project">
                <a href="https://dracyze.com" rel="noreferrer" target="_blank">
                <img src={decrayze} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://dracyze.com" rel="noreferrer" target="_blank">Dracyze - E-commerce Store</a></h2>
                <p>A clean, responsive, premium look WooCommerce store showcasing trendy clothing collections with seamless fast and smooth checkout system.</p>
            </div>
             <div className="project">
                <a href="https://marudeva.com" rel="noreferrer" target="_blank">
                <img src={marudeva} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://marudeva.com" rel="noreferrer" target="_blank">Marudeva - E-commerce Store</a></h2>
                <p>A modern, visually refined website developed from different design references layouts to present high-end e-commerce products effectively.</p>
            </div>
                    <div className="project">
                <a href="https://amritresidency.in" rel="noreferrer" target="_blank">
                <img src={amrit} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://amritresidency.in" rel="noreferrer" target="_blank">Amrit Residency – Premium PG & Rental Accommodation</a></h2>
                <p>Developed a modern, responsive website for a premium PG and rental accommodation provider, showcasing comfortable living spaces, amenities, and a seamless user experience for students and working professionals.</p>
            </div>
            <div className="project">
                <a href="https://vavodigital.com" rel="noreferrer" target="_blank">
                <img src={vavo} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://vavodigital.com" rel="noreferrer" target="_blank">Vavo Digital - Influencer Marketing Agency</a></h2>
                <p>A modern, visually refined website developed from different design references layouts to present high-end influencer marketing services effectively.</p>
            </div>
            <div className="project">
                <a href="https://podcrafter.techaura.in" rel="noreferrer" target="_blank">
                <img src={podcrafter} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://podcrafter.techaura.in" rel="noreferrer" target="_blank">Podcrafter Studio - Podcast Platform</a></h2>
                <p>A modern, visually refined WordPress website for a podcast platform agency with seamless UI effects and user-friendly interface.</p>
            </div>
            <div className="project">
                <a href="https://supplementfarm.in" rel="noreferrer" target="_blank">
                <img src={supplementfarm} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://supplementfarm.in" rel="noreferrer" target="_blank">Supplement Farm – Fitness & Wellness Supplements</a></h2>
                <p>Developed a modern, responsive eCommerce website for a fitness and wellness brand, showcasing authentic nutritional supplements with an intuitive shopping experience and optimized product browsing.</p>
            </div>
            <div className="project">
                <a href="https://stelliamholidays.com" rel="noreferrer" target="_blank">
                <img src={stelliam} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://stelliamholidays.com" rel="noreferrer" target="_blank">Stelliam Holidays - Travel & Tourism</a></h2>
                <p>A modern, visually refined, smooth website developed from different design references layouts to present high-end travel and tourism services effectively.</p>
            </div>
            <div className="project">
                <a href="https://genzephyr.com" rel="noreferrer" target="_blank">
                <img src={genzephyr} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://genzephyr.com" rel="noreferrer" target="_blank">Genzephyr - E-commerce Store</a></h2>
                <p>A stylish WooCommerce e-commerce site with smooth dropshipping integration for effortless product management.</p>
            </div>
            <div className="project">
                <a href="https://urbannxtinfra.com" rel="noreferrer" target="_blank">
                <img src={urbannext} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://urbannxtinfra.com" rel="noreferrer" target="_blank">Urbannxt Infra - Investment Company</a></h2>
                <p>Urbannxt Infra – A clean, responsive website developed in WordPress for Real Estate, Land and Industrial Investment in Gujarat.</p>
            </div>
            <div className="project">
                <a href="https://8elitenutrition.com" rel="noreferrer" target="_blank">
                <img src={elite} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://8elitenutrition.com" rel="noreferrer" target="_blank">8 Elite Nutrition - E-commerce Store</a></h2>
                <p>A premium WooCommerce store built to present the supplement brand, offering a clean, trustworthy shopping experience and featuring customized offers on purchase.</p>
            </div>
            <div className="project">
                <a href="https://luxuriaautomotive.com" rel="noreferrer" target="_blank">
                <img src={luxuria} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://luxuriaautomotive.com" rel="noreferrer" target="_blank">Luxuria Automotive – Luxury Car Sales, Finance & Insurance</a></h2>
                <p>Developed a premium, responsive website for a luxury automotive company, showcasing new and pre-owned vehicle sales, financing, and insurance services with a seamless and sophisticated user experience.</p>
            </div>
            <div className="project">
                <a href="https://sweetroars.com" rel="noreferrer" target="_blank">
                <img src={sweetroars} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://sweetroars.com" rel="noreferrer" target="_blank">Sweet Roars – Custom Cakes & Home Bakery</a></h2>
                <p>Developed a modern, responsive website for a home bakery, showcasing custom cakes, baked goods, and handcrafted desserts with an engaging design and seamless browsing experience.</p>
            </div>
            <div className="project">
                <a href="https://parimishabearings.com" rel="noreferrer" target="_blank">
                <img src={parimisha} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://parimishabearings.com" rel="noreferrer" target="_blank">Pari Misha Bearings – Industrial Bearings & Chemical Solutions</a></h2>
                <p>Developed a professional, responsive website for an industrial supplier, showcasing premium bearing brands, industrial and construction chemical solutions, and an intuitive user experience for businesses across India.</p>
            </div>
            <div className="project">
                <a href="https://ultucup.com" rel="noreferrer" target="_blank">
                <img src={ultucup} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://ultucup.com" rel="noreferrer" target="_blank">UltuCup – Sustainable Reusable Cup Solutions</a></h2>
                <p>Developed a modern, responsive website for an eco-friendly brand, showcasing sustainable reusable cups, product features, and a clean, engaging user experience focused on environmental responsibility.</p>
            </div>
            <div className="project">
                <a href="https://goglobemigrations.com" rel="noreferrer" target="_blank">
                <img src={goglobe} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://goglobemigrations.com" rel="noreferrer" target="_blank">Go Globe Migrations – Immigration & Visa Consultancy</a></h2>
                <p>Developed a professional, responsive website for an immigration consultancy, showcasing student, family, skilled, and spouse visa services with a streamlined user experience for prospective clients.</p>
            </div>
            <div className="project">
                <a href="https://arkenroofing.com" rel="noreferrer" target="_blank">
                <img src={arken} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://arkenroofing.com" rel="noreferrer" target="_blank">Arken Roofing - Roofing Company</a></h2>
                <p>A clean, responsive full customized premium website developed in WordPress for roofing services in USA.</p>
            </div>
            <div className="project">
                <a href="https://melavi.in" rel="noreferrer" target="_blank">
                <img src={melavi} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://melavi.in" rel="noreferrer" target="_blank">Melavi - E-commerce Store</a></h2>
                <p>A clean, responsive, premium look WooCommerce store showcasing trendy clothing collections with seamless fast and smooth checkout system.</p>
            </div>
            <div className="project">
                <a href="https://creatingfutures.in" rel="noreferrer" target="_blank">
                <img src={cf} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://creatingfutures.in" rel="noreferrer" target="_blank">Creating Futures - NGO</a></h2>
                <p>A modern WordPress platform created to showcase the Creating Futures work in advancing children education and women empowerment, along with their inspiring achievements and stories.</p>
            </div>
            <div className="project">
                <a href="https://accelance.io" rel="noreferrer" target="_blank">
                <img src={accelence} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://accelance.io" rel="noreferrer" target="_blank">Accelance - Figma to Wordpress</a></h2>
                <p>Accelance – A clean, responsive custom website developed with Figma to WordPress to showcase about Business and Automation services.</p>
            </div>
            <div className="project">
                <a href="https://events.cicluk.co.uk" rel="noreferrer" target="_blank">
                <img src={ciclevent} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://events.cicluk.co.uk" rel="noreferrer" target="_blank">CICL Events - Registration Landing Page</a></h2>
                <p>A clean, responsive custom landing page for ticket registration optimized using funnel system to nurture leads and auto response enquiry features, showcasing about Business and automated response.</p>
            </div>
            <div className="project">
                <a href="https://admin.madversemedia.com" rel="noreferrer" target="_blank">
                <img src={citycool} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://admin.madversemedia.com" rel="noreferrer" target="_blank">City Cool - Business Landing Page</a></h2>
                <p>A clean, responsive custom landing page for City Cool, optimized using funnel system to nurture leads and auto response enquiry features, showcasing about business and services.</p>
            </div>
            <div className="project">
                <a href="https://cheersup.co.in" rel="noreferrer" target="_blank">
                <img src={cheerup} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://cheersup.co.in" rel="noreferrer" target="_blank">Cheer Up - Business Landing Page</a></h2>
                <p>A clean, responsive custom landing page for Cheer Up, optimized for showcasing about business product.</p>
            </div>
            <div className="project">
                <a href="https://soildidi.com" rel="noreferrer" target="_blank">
                <img src={soil} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://soildidi.com" rel="noreferrer" target="_blank">Soil Doctor – Agri E-Commerce Platform</a></h2>
                <p>A robust WordPress/WooCommerce website built to deliver agricultural solutions and farming products, offering farmers seamless access to quality supplies, expert guidance, and a reliable e-commerce experience.</p>
            </div>
            <div className="project">
                <a href="https://digieminence.co.in" rel="noreferrer" target="_blank">
                <img src={digi} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://digieminence.co.in" rel="noreferrer" target="_blank">Digi Eminence - Digital Marketing Agency</a></h2>
                <p>Accelance – A clean, responsive custom website developed with Figma to WordPress to showcase about Business and Automation services.</p>
            </div>
            <div className="project">
                <a href="https://greenlymortgage.com" rel="noreferrer" target="_blank">
                <img src={greenly} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://greenlymortgage.com" rel="noreferrer" target="_blank">Greenly Mortgage - Mortgage Solutions</a></h2>
                <p>A clean, intuitive WordPress site offering comprehensive mortgage services, helping clients find the right home financing options with clarity and confidence.</p>
            </div>
            <div className="project">
                <a href="https://www.logsday.com" rel="noreferrer" target="_blank">
                <img src={logsday} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://www.logsday.com" rel="noreferrer" target="_blank">LogsDay - Daily Tips & Blogging</a></h2>
                <p>A clean, intuitive WordPress site offering comprehensive blogging and daily tips, helping readers stay informed and inspired with engaging content.</p>
            </div>
            <div className="project">
                <a href="https://saaksham.com" rel="noreferrer" target="_blank">
                <img src={saaksham} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://saaksham.com" rel="noreferrer" target="_blank">Saaksham - Blogging Website</a></h2>
                <p>A sleek, content-rich WordPress blog designed to share insights, stories, and expert perspectives, delivering a thoughtful reading experience for curious and engaged readers.</p>
            </div>
            <div className="project">
                <a href="https://www.trumbullcountyhistory.com" rel="noreferrer" target="_blank">
                <img src={trumbul} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://www.trumbullcountyhistory.com" rel="noreferrer" target="_blank">Trumbull County History - Historical Museum</a></h2>
                <p>A comprehensive WordPress site of over 60 pages dedicated to the Trumbull County Historical Society, showcasing rich archival collections, exhibits, and community stories that preserve and celebrate the region’s heritage.</p>
            </div>
            <div className="project">
                <a href="https://www.mittulshah.com/" rel="noreferrer" target="_blank">
                <img src={mittul} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://www.mittulshah.com/" rel="noreferrer" target="_blank">Mittul Shah - Freelancer Website</a></h2>
                <p>Mittul Shah - Freelancer – A clean, responsive website developed in WordPress to showcase about freelancer and marketing services.</p>
            </div>
            <div className="project">
                <a href="https://cicluk.co.uk" rel="noreferrer" target="_blank">
                <img src={cicl} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://cicluk.co.uk" rel="noreferrer" target="_blank">CICL (UK) - Investment & Consulting</a></h2>
                <p>CICL (UK) - Investment & Consulting – A clean, responsive custom website developed in WordPress to showcase about Investment opportunities and consulting services.</p>
            </div>
            <div className="project">
                <a href="https://trueviewlandscaping.com" rel="noreferrer" target="_blank">
                <img src={trueview} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://trueviewlandscaping.com" rel="noreferrer" target="_blank">True View Landscaping</a></h2>
                <p>True View Landscaping – A clean, responsive website developed in WordPress to showcase landscaping and maintenance services.</p>
            </div>
            <div className="project">
            <a href="https://orderonwheels.com" rel="noreferrer" target="_blank">
                <img src={oow} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://orderonwheels.com" rel="noreferrer" target="_blank">Order On Wheels</a></h2>
                <p>Order On Wheels – A dynamic food ordering platform developed in WordPress, offering seamless browsing and ordering from local vendors.</p>
            </div>
            <div className="project">
            <a href="https://victorsqualityremodeling.com" rel="noreferrer" target="_blank">
                <img src={victory} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://victorsqualityremodeling.com" rel="noreferrer" target="_blank">Victor's Quality Remodeling</a></h2>
                <p>Victor's Quality Remodeling – A WordPress-based website showcasing home remodeling and renovation services with a clean, professional layout.</p>
            </div>
            <div className="project">
                <a href="https://tresdiascleveland.org" rel="noreferrer" target="_blank">
                <img src={tresdias} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://tresdiascleveland.org" rel="noreferrer" target="_blank">Tres Dias Cleveland</a></h2>
                <p>Tres Dias Cleveland – A WordPress site built for a Christian community, featuring event info, registrations, and spiritual resources.</p>
            </div>
            <div className="project">
                <a href="https://perfectpalapastx.com" rel="noreferrer" target="_blank">
                <img src={paralaps} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://perfectpalapastx.com" rel="noreferrer" target="_blank">Perfect Palapas TX</a></h2>
                <p>Perfect Palapas TX – A vibrant WordPress site showcasing custom palapa and outdoor living solutions with project galleries and service details.</p>
            </div>
            <div className="project">
            <a href="https://laapressurewashing.com" rel="noreferrer" target="_blank">
                <img src={pressurewashing} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://laapressurewashing.com" rel="noreferrer" target="_blank">LAA Pressure Washing</a></h2>
                <p>LAA Pressure Washing – A clean and professional WordPress site highlighting residential and commercial pressure washing services.</p>
            </div>
            <div className="project">
            <a href="https://sototrim.com" rel="noreferrer" target="_blank">
                <img src={sototrim} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://sototrim.com" rel="noreferrer" target="_blank">SotoTrim Company</a></h2>
                <p>SotoTrim – A sleek WordPress website showcasing expert automotive trimming and restyling services with a strong visual portfolio.</p>
            </div>
            <div className="project">
                <a href="https://housefullentertainment.com" rel="noreferrer" target="_blank">
                <img src={housefull} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://housefullentertainment.com" rel="noreferrer" target="_blank">Housefull Entertainment - Landing Page</a></h2>
                <p>Housefull Entertainment – A clean, responsive landing page developed in WordPress to showcase about Event Management and services.</p>
            </div>
            <div className="project">
                <a href="https://yipeezy.net" rel="noreferrer" target="_blank">
                <img src={yippezy} className="zoom" alt="thumbnail" width="100%"/>
                </a>
               <h2><a href="https://yipeezy.net" rel="noreferrer" target="_blank">Yipeezy LLC - Custom Landing Page</a></h2>
                <p>Yipeezy LLC – A clean, responsive custom landing page developed in WordPress to showcase about Business and consulting services.</p>
                
            </div>
            <div className="project">
                <a href="https://travelinfoline.us" rel="noreferrer" target="_blank">
                <img src={travelinfoline} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://travelinfoline.us" rel="noreferrer" target="_blank">Travel Info Line</a></h2>
                <p>Travel Info Line – An informative WordPress site offering travel guides, tips, and destination insights for U.S. travelers.</p>
            </div>
            <div className="project">
                <a href="https://orafinancials.com" rel="noreferrer" target="_blank">
                <img src={ora} className="zoom" alt="thumbnail" width="100%"/>
                </a>
                <h2><a href="https://orafinancials.com" rel="noreferrer" target="_blank">Ora Financials</a></h2>
                <p>Ora Financials – A professional WordPress website showcasing financial services and consulting expertise.</p>
            </div>
        </div>
    </div>
  )
}
